import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import {
  CookiePreferences,
  DEFAULT_COOKIE_PREFERENCES,
  OPTIONAL_COOKIE_SERVICES,
  OptionalCookiePreference,
} from '../../core/privacy/cookie-preferences';
import {
  CookieConsentService,
  CookieConsentState,
} from '../../core/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent implements OnInit, OnDestroy {
  readonly optionalServices = OPTIONAL_COOKIE_SERVICES;
  readonly state$: Observable<CookieConsentState>;

  draft: CookiePreferences = { ...DEFAULT_COOKIE_PREFERENCES };

  private readonly subscription = new Subscription();
  private wasDialogOpen = false;

  constructor(
    private readonly cookieConsentService: CookieConsentService,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.state$ = this.cookieConsentService.state$;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.state$.subscribe((state) => {
        if (state.isDialogOpen && !this.wasDialogOpen) {
          this.draft = { ...state.preferences };
        }

        this.document.body.classList.toggle(
          'cx-cookie-dialog-open',
          state.isDialogOpen
        );
        this.wasDialogOpen = state.isDialogOpen;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.document.body.classList.remove('cx-cookie-dialog-open');
  }

  shouldShowBanner(state: CookieConsentState): boolean {
    const currentPath = this.router.url.split(/[?#]/, 1)[0];

    return (
      state.isReady && !state.hasSavedPreference && currentPath !== '/cookies'
    );
  }

  openPreferences(event?: Event): void {
    const opener =
      event?.currentTarget instanceof HTMLElement ? event.currentTarget : null;
    this.cookieConsentService.openPreferences(opener);
  }

  closePreferences(): void {
    this.cookieConsentService.closePreferences();
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
  }

  rejectOptional(): void {
    this.cookieConsentService.rejectOptional();
  }

  savePreferences(): void {
    this.cookieConsentService.savePreferences(this.draft);
  }

  setPreference(preference: OptionalCookiePreference, event: Event): void {
    const input = event.target as HTMLInputElement;

    this.draft = {
      ...this.draft,
      [preference]: input.checked,
    };
  }
}
